var exports = {
  "p_": "list__rNVsNg",
  "$A": "streaming__1FACJP",
  "Lb": "withToggle__HTq_NA",
  "AS": "item__xvKs-r",
  "nf": "link__iSIWIX",
  "Qs": "content__k0vvMg",
  "yu": "metadata__vr2YJT",
  "wx": "header__fRFg-T",
  "DD": "title__7Bbz3s",
  "ZI": "unknownTitle__MPlWoe",
  "ai": "number__TNNd1s",
  "WD": "labels__83mU1a",
  "Pf": "label__ZWI9oU",
  "IX": "labelIcon__-YffcK",
  "h_": "description__WpnpqQ",
  "Kk": "icon__VuJHSg",
  "ho": "open__OH-icJ",
  "K4": "draft__M7vbqi",
  "Vw": "done__rqkMfm",
  "$h": "closed__Xt-jS3",
  "oE": "checkIcon__U1zqSA",
  "mU": "stopIcon__xQDCGX",
  "KO": "dotFillIcon__LhVb1f",
  "BD": "unassignedAvatar__R8sOa5",
  "yn": "toggleContent__GGRCsZ",
  "Rm": "toggleButton__jf14F1",
  "iM": "shimmer__i8aAnc",
  "D5": "shimmerMove__OawxLb",
  "ym": "toggleIcon__-tnTGo",
};

module.exports = exports;
